import { memo } from 'react';
import NextLink from 'next/link';
import { Link } from '@chakra-ui/react';

import { useHeaderBoundStore } from 'app/selectors';
import UnderlinedText from 'shared/UnderlinedText';

import { EMPTY_OBJECT } from 'constants/global';

const NavItem = ({ text, link = null, menuData = null }) => {
  const { isMenuOpen, isOverlapsFooter, setIsLight, updateHeaderMenuState, updateHeaderMenuData } =
    useHeaderBoundStore();
  const isHttp = link?.startsWith('http');

  return (
    <>
      {link ? (
        <Link
          as={isHttp ? 'a' : NextLink}
          href={link}
          w="full"
          isExternal={isHttp}
          textDecor="none"
          _hover={EMPTY_OBJECT}
        >
          <NavText
            text={text}
            onMouseEnter={() => {
              updateHeaderMenuState('close');
              updateHeaderMenuData('reset');
            }}
          />
        </Link>
      ) : (
        <NavText
          text={text}
          onMouseEnter={() => {
            !isMenuOpen && updateHeaderMenuState('open');
            updateHeaderMenuData('set', menuData);
            isOverlapsFooter && setIsLight(false);
          }}
        />
      )}
    </>
  );
};

const NavText = ({ text, ...props }) => {
  const { isLight, headerMenuData } = useHeaderBoundStore();
  const isActiveTab = text === headerMenuData.title;

  return (
    <UnderlinedText
      trigger={isActiveTab}
      textStyle="button.header"
      whiteSpace="nowrap"
      lineProps={{ bgColor: `bg.${isLight ? 'white' : 'black'}` }}
      {...props}
    >
      {text}
    </UnderlinedText>
  );
};

export default memo(NavItem);
